import { cardReaderMixin } from './cardReader';

/**
 * Podpinanie eventu keyup do nasłuchiwania wprowadzania numeru karty
 * Wykorzystuje cardReader mixin
 * Zawiera metody:
 * - `keyUp` - odczytuje cyfry i dopisuje je do cardNumber/ wysyła do store na enter
 */
export const eventCardReaderMixin = {
  mixins: [cardReaderMixin],

  /**
   * Podpięcie event listenera do zdarzenia keyup
   */
  mounted() {
    window.addEventListener('keyup', this.keyUp);
  },

  /**
   * Odpięcie event listenera przed destroy komponentu
   */
  beforeDestroy() {
    window.removeEventListener('keyup', this.keyUp);
  },
  methods: {
    /**
     *  Dodawanie cyfr do cardnumber i zatwierdzanie enterem
     *
     * @param {*} event - keyup event
     */
    keyUp(event) {
      if (event.target.localName === 'input') {
        return;
      }
      if (!isNaN(parseInt(event.key, 10))) {
        this.cardReader.cardNumber += event.key;
      } else if (event.key === 'Enter') {
        if (!this.cardReader.cardNumber.length) {
          return;
        }
        this.submitCardNumber();
      } else {
        this.clearCardNumber();
      }
    }
  }
};
